import React from 'react'
import { twMerge } from 'tailwind-merge'

interface DropBoxProps {
  dropTop?: boolean
  canDrop?: boolean
  dropBottom?: boolean
  children?: React.ReactNode
  className?: string
}

export const DropBox = React.forwardRef<
  HTMLTableElement,
  DropBoxProps & React.TableHTMLAttributes<HTMLTableElement>
>(
  (
    { dropTop = false, canDrop = false, dropBottom = false, children, className, ...props },
    ref,
  ) => {
    return (
      <table
        ref={ref}
        className={twMerge(
          'main-transition-colors w-full',
          canDrop && 'bg-brand-primary/10',
          canDrop && dropTop && 'shadow-brand-primary/70 shadow-[0px_-3px_0px_0px]',
          canDrop && dropBottom && 'shadow-brand-primary/70 shadow-[0px_3px_0px_0px]',
          className,
        )}
        {...props}
      >
        {children}
      </table>
    )
  },
)

DropBox.displayName = 'DropBox'
